export default __webpack_public_path__ + "static/char-s-17-kr-802122b9e2bba8317a18bbadc3a7dd6a.png";